const DojoWebPosResult = require('@/lib/PaymentMethods/Dojo/Enums/DojoWebPosResult');

/**
 * This class is automatically loaded in development and matches the Dojo WebPos API. The helper functions allow the
 * developer to simulate responses by calling the functions from the console.
 */
class DojoWebPosSimulator {
    /**
     * This stores the amount in minor units e.g. pence.
     *
     * @param {number} amount
     */
    amount = 0;

    TAP_EXIT() {
        alert('Exit the WebView into the WebPOS home screen. This functionality is not implemented in the simulator');
        console.log('WebPOS.TAP_EXIT');
    }

    SHOW_MENU() {
        alert('Show the WebPOS settings sheet. This functionality is not implemented in the simulator');
        console.log('WebPOS.SHOW_MENU');
    }

    /**
     * @param {number} amount
     */
    INIT_SALE(amount) {
        this.amount = amount;
        console.log('WebPOS.INIT_SALE', amount);
    }

    /**
     * @param {number} amount
     */
    INIT_REFUND(amount) {
        this.amount = amount;
        console.log('WebPOS.INIT_REFUND', amount);
    }

    tapSuccess() {
        window.saleOutcome(DojoWebPosResult.SUCCESS, window.WebPOS.amount, 0);
    }

    tapFail() {
        window.saleOutcome(DojoWebPosResult.FAILURE, this.amount, 0);
    }

    /**
     * @param {number} tipInPence
     */
    tapSuccessWithTip(tipInPence = 0) {
        window.saleOutcome(DojoWebPosResult.SUCCESS, window.WebPOS.amount, tipInPence);
    }

    refundSuccess() {
        window.refundOutcome(DojoWebPosResult.SUCCESS);
    }

    refundFail() {
        window.refundOutcome(DojoWebPosResult.FAILURE);
    }
}

window.WebPOS = new DojoWebPosSimulator();
